import React from 'react';
import { createPortal } from 'react-dom';
import "./PopUp.scss";

const PopUp = ({ children, active, onClose }) => {
  if (!active) return null;

  return createPortal(
    <div className="PopUp">
      <div className="pop-up-backdrop" onClick={onClose} />
      <div className="pop-up">
        <div className="container-pop-up">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PopUp;
